import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="google-site-verification" content="SS_dmvkkvjW0m4Hxa2yhun9iAfeLG-p9sk_PwN82FZw" />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Vorpoint IT-Solutions | Digitalisierung für den Mittelstand',
  description: 'Vorpoint ist Ihr Partner für die Digitalisierung des deutschen Mittelstands. Wir bieten maßgeschneiderte IT-Lösungen, Webanwendungen und Datenanalyse.',
  keywords: 'Digitalisierung, Mittelstand, IT-Lösungen, Webanwendungen, Datenanalyse, Vorpoint, Ahmed Tahhan',
};

export default Meta;